if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      /* Todanua, rodada 3: resultado CONFIRMADO de cada adição, com id próprio da operação.
         `td:cart-add` sai uma vez por envio aceito, com ok=true só depois da resposta sem erro
         do /cart/add. Quem pediu "Comprar agora" marca `tdIntent` no elemento ANTES do
         requestSubmit; o envio aceito consome a marca e ela viaja dentro da operação. Envio
         barrado pela validação (td-pdp.js, em captura) nunca chega aqui, então nunca consome
         a marca — e o td-buy-now a apaga logo depois. Assim, "Comprar agora" sem tamanho
         seguido de "Adicionar" não vira checkout. */
      tdSignal(op, ok, extra) {
        if (!op) return;
        try {
          document.dispatchEvent(
            new CustomEvent('td:cart-add', { detail: Object.assign({ op: op, ok: ok }, extra || {}) })
          );
        } catch (e) {}
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const tdIntent = this.tdIntent || null;
        this.tdIntent = null;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // Give the app time to attach its cart listeners before the first purchase.
        const tdApp = window.__tdPlataformaPronta ? await window.__tdPlataformaPronta(3000) : { estado: 'app-indisponivel' };
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        // Esta operação prepara a medição com o corpo que o formulário já leu.
        config.tdAtcProprio = typeof window.__tnAtcPreparar === 'function';
        const tdAutorizacao = window.__tnAtcAutorizacao ? window.__tnAtcAutorizacao() : null;
        let tdMedicao = tdApp;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const tdAppOp = window.__tdAppMedicao && window.__tdAppMedicao.iniciar(variantId);
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);
        const tdOp = {
          id: 'op.' + Date.now() + '.' + Math.random().toString(36).slice(2, 9),
          intent: tdIntent,
          variantId: String(variantId || ''),
          quantity: quantity,
        };
        this.tdSignal(tdOp, null, { stage: 'start' });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json().then((data) => {
            // Mesmo um erro JSON sem campo status deve seguir o caminho de rejeição.
            if (!response.ok) return Object.assign({}, data, {
              status: data?.status || response.status,
              description: data?.description || data?.message || window.cartStrings?.error,
            });
            return data;
          }))
          .then((response) => {
            if (!response.status && tdAppOp) tdMedicao = window.__tdAppMedicao.aguardar(tdAppOp, 3000);
            if (!response.status && config.tdAtcProprio) {
              tdMedicao = window.__tnAtcPreparar(formData, response, tdAutorizacao);
            }
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));
              this.tdSignal(tdOp, false, { reason: 'rejected', status: response.status });

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              const tdCartSemGaveta = this.resolveCartLinesUpdate(linesUpdateDeferred);
              this.tdSignal(tdOp, true, { cartData: response, medicao: tdMedicao, settled: tdCartSemGaveta });
              /* "Comprar agora" decide o destino dele; só a adição normal vai para /cart. */
              if (!tdIntent) window.location = window.routes.cart_url;
              return;
            }

            const tdCartPronto = this.resolveCartLinesUpdate(linesUpdateDeferred);
            this.tdSignal(tdOp, true, { cartData: response, medicao: tdMedicao, settled: tdCartPronto });

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
            this.tdSignal(tdOp, false, { reason: 'network' });
            /* Rodada 4 (R3-09): erro de rede agora aparece para a cliente (antes só no console). */
            if (!tdIntent && window.cartStrings && window.cartStrings.error) this.handleErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      /* Rodada 5: devolve {ok, motivo}; falha de leitura não vira sucesso.
         O evento padrão da Shopify recebe a rejeição correspondente. O "Comprar agora" espera por ela antes de navegar: a navegação cancelava o
         /cart.json no meio e o evento caía em "Missing currency in cart response". */
      resolveCartLinesUpdate(deferred) {
        if (!deferred) return Promise.resolve({ ok: false, motivo: 'evento-indisponivel' });
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return Promise.resolve({ ok: false, motivo: 'evento-indisponivel' });

        const pendingCartDataPromise = Promise.resolve().then(() => typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => {
              if (!response.ok) throw new Error('Cart HTTP ' + response.status);
              return response.json();
            }));

        return pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) throw new Error('Missing currency in cart response');
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
            return { ok: true };
          })
          .catch((e) => { deferred.reject(e); return { ok: false, motivo: 'erro-leitura', erro: e.message }; });
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
